import SVGTemplate from './SVGTemplate.vue';
import MapTemplate from './MapTemplate.vue';
import ControlsTemplate from './ControlsTemplate.vue';

export * from './types';
export * from './formatters';
export * from './mercatorProjection';
export {
    SVGTemplate as default,
    SVGTemplate,
    MapTemplate,
    ControlsTemplate
};
